import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import Button from '../../../Form/Button';

interface Props {
  onDiscardChanges: () => void;
  onKeepEditing: () => void;
}

function UnsavedChangesModal({ onDiscardChanges, onKeepEditing }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8">
        <h3 className="text-xl font-semibold mb-4">
          <T kind="Unsaved Changes" />
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          <T kind="You have unsaved changes. Please..." />
        </p>
        <div className="flex justify-end gap-3">
          <Button
            type="button"
            value="Keep Editing"
            onClick={onKeepEditing}
            className="rounded-md bg-white border-gray-900 px-4 py-2 text-sm text-gray-900 hover:bg-white hover:text-gray-900 hover:border-gray-900"
            data-intercom-target="edit-group-unsaved-keep-editing-button"
          />
          <Button
            type="button"
            value="Discard Changes"
            onClick={onDiscardChanges}
            className="rounded-md bg-red-600 border-red-600 px-4 py-2 text-sm text-white hover:bg-red-700 hover:border-red-700"
            data-intercom-target="edit-group-unsaved-discard-button"
          />
        </div>
      </div>
    </div>
  );
}

export default observer(UnsavedChangesModal);
